<script>
import Button from "@/components/reusable/Button.vue";

export default {
  name: "ProfileContainer",
  components: {Button},
  props: {
    heading: {
      type: String,
      required: true,
    },
    text: {
      type: Array,
      required: true,
    },
    altText: {
      type: String,
    },
  },
};
</script>


<template>
  <div
      class="bg-secondary-light dark:bg-secondary-dark p-6 sm:p-10 rounded-lg shadow-lg mt-10 sm:mt-20 flex flex-col sm:flex-row items-center gap-6">

    <img
        src="@/assets/images/profile.jpeg"
        alt=""
        class="w-28 h-28 sm:w-36 sm:h-36 rounded-full border-4 border-secondary-dark dark:border-secondary-light"
    />

    <div class="text-center">
      <h1 class="text-2xl sm:text-3xl font-bold">{{ heading }}</h1>
      <div class="mt-2 text-base sm:text-lg">
        <p v-for="(paragraph, index) in text" :key="index" class="mb-4">
          {{ paragraph }}
        </p>
      </div>

      <div class="mt-4 flex justify-center w-full">
        <a
            download="CV-Sian-Lauwers.pdf"
            href="/files/CV-Sian-Lauwers.pdf"
            target="_blank"
            rel="noopener noreferrer"
            class="font-general-medium flex items-center px-6 py-3 rounded-lg shadow-lg hover:shadow-xl bg-indigo-500 hover:bg-indigo-600 focus:ring-1 focus:ring-indigo-900 text-white text-lg sm:text-xl duration-300"
            aria-label="Download Resume"
        >
          <Button title="Download CV"/>
        </a>
      </div>
    </div>
  </div>
</template>


<style scoped>
/* Add additional custom styles here if required */
</style>
